import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useDropdowns} from "../../../../hooks/useDropdowns";
import {getDeviceDetails} from "../../../../Services/device";
import {SET_IS_API_CALLED, SET_IS_API_CALLED_FINISHED} from "../../../../store/features/loadingSlice";
import {Controller} from "react-hook-form";
import WorkforceDetailsFieldComponent from "../../../../components/WorkForce/WorkforceDetailsFieldComponent";
import {Input, Select} from "antd";
import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";
import {NOW_UTC_OFFSET} from "../../../../constant";
import {
    SET_CREATE_WORKFORCE_CASE_DETAILS,
    SET_EDIT_WORKFORCE_CASE_DETAILS
} from "../../../../store/features/workforceSlice";

function EditableAlarmCaseDetails({ control, setValue, watch, reset}) {
    const dispatch = useDispatch();
    const {state, getAlarmTypesDropDown, getAllDevicesDropdown, getTechnicianGroupsDropdown, getAllCaseTypeDropdown} = useDropdowns();
    const {email: userEmail} = JSON.parse(localStorage.getItem("userData"));
    const [meterDetailsData, setMeterDetailsData] = useState({});
    const { workforceCaseDetails } = useSelector((state) => state.Workforce);

    // const { setValue} = useForm();

    useEffect(() => {
        reset(workforceCaseDetails);
        getAllCaseTypeDropdown();
        getAlarmTypesDropDown();
        getAllDevicesDropdown();
    }, []);



    const getMeterDetailsOnChange = (val) => {
        getDeviceDetails(val).then(response => {
            dispatch(SET_CREATE_WORKFORCE_CASE_DETAILS({
                address: response?.data?.address1 + response?.data?.address2,
                // if the geocode is wrong, it could be due to it processing the logger and meter data together
                geocode: `${response?.data?.meter?.latitude ?? response?.data?.logger?.latitude} , ${response?.data?.meter?.longitude ?? response?.data?.logger?.longitude}`,

            }));
            setMeterDetailsData(response?.data);
            setValue('region', response?.data?.city);
        });
    }

    useEffect(() => {
        const region = watch("region");
        if (region !== null && region !== undefined) {
            setTechnicianGroupData(region); //AIS23EM00116

        }
    }, [watch("region")])

    const setTechnicianGroupData = (regionData) => {
        dispatch(SET_IS_API_CALLED("Retrieving Technician Groups"));
        getTechnicianGroupsDropdown({region: regionData})
            .finally(() => {
                dispatch(SET_IS_API_CALLED_FINISHED());
            });
    }

    return (
        <div className="grid grid-cols-2 gap-5">
            <Controller
                name="caseIdStr"
                control={control}
                defaultValue={workforceCaseDetails?.caseIdStr}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent fieldName={"Case ID"} fieldId={"caseIdStr"}>
                        <Input
                            placeholder=""
                            id={"caseIdStr"}
                            disabled
                            value={field.value}
                            onChange={field.onChange}/>
                    </WorkforceDetailsFieldComponent>)}
            />

            <Controller
                name="alarmTypeId"
                control={control}
                defaultValue={workforceCaseDetails?.alarmType?.id}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent
                        fieldName={"Alarm Type"}
                        fieldId={"alarmType"}
                    >
                        <Select
                            placeholder={"Select a value"}
                            value={field.value}
                            id={"alarmType"}
                            onChange={field.onChange}
                            options={state?.alarmTypesDropDown.map((statusTypes) => {
                                return {
                                    label: statusTypes?.name,
                                    value: statusTypes?.id,
                                };
                            })}
                            className={
                                "w-full font-light placeholder:text-light-grey-500"
                            }
                        />
                    </WorkforceDetailsFieldComponent>
                )}
            />

            <Controller
                name="creationDate"
                control={control}
                defaultValue={NOW_UTC_OFFSET()}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent
                        fieldName={"Creation Date"}
                        fieldId={"creationDate"}
                    >
                        <Input
                            id={"creationDate"}

                            disabled
                            value={dayjs(field.value)}
                            onChange={field.onChange}
                        />
                    </WorkforceDetailsFieldComponent>
                )}
            />

            <Controller
                name="deviceId"
                control={control}
                defaultValue={workforceCaseDetails?.device?.deviceId}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent
                        fieldName={"Meter ID"}
                        fieldId={"meterId"}
                    >
                        <Select
                            showSearch
                            placeholder={"Select a value"}
                            value={field.value}
                            options={state?.devices.map((statusTypes) => {
                                return {
                                    label: statusTypes?.name,
                                    value: statusTypes?.id,
                                };
                            })}
                            filterOption={(input, option) =>
                                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }

                            onChange={(val) => {
                                getMeterDetailsOnChange(val);
                                field.onChange(val);
                            }}
                            className={
                                "w-full font-light placeholder:text-light-grey-500"
                            }
                        />
                    </WorkforceDetailsFieldComponent>
                )}
            />

            <Controller
                name="createdBy"
                control={control}
                defaultValue={userEmail}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent
                        fieldName={"Created By"}
                        fieldId={"createdBy"}
                    >
                        <Input
                            placeholder="someone@example.com"
                            id={"createdBy"}
                            value={field.value}
                            onChange={field.onChange}
                            disabled/>
                    </WorkforceDetailsFieldComponent>
                )}
            />
            <WorkforceDetailsFieldComponent
                fieldName={"Installation Date"}
                fieldId={"installationDate"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    value={workforceCaseDetails?.device?.installationDate}
                    id={"installationDate"}
                />
            </WorkforceDetailsFieldComponent>


            <Controller
                name="caseTypeId"
                control={control}
                defaultValue={workforceCaseDetails?.caseType?.id}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent
                        fieldName={"Case Type"}
                        fieldId={"caseType"}
                    >
                        <Select
                            placeholder={"Select a value"}
                            value={field.value}
                            id={"caseType"}
                            onChange={field.onChange}
                            options={state?.caseTypes?.map((caseTypes) => {
                                return {
                                    label: caseTypes?.name,
                                    value: caseTypes?.id,
                                };
                            }) ?? []}
                            className={
                                "w-full font-light placeholder:text-light-grey-500"
                            }
                        />
                    </WorkforceDetailsFieldComponent>
                )}
            />

            <Controller
                name="region"
                control={control}
                defaultValue={workforceCaseDetails?.region}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent fieldName={"Region"} fieldId={"region"}>
                        <Input
                            disabled={true}
                            placeholder=""
                            id={"region"}
                            value={field.value} //
                            onChange={(val) => {
                                field.onChange(val);
                                setTechnicianGroupData(val);
                            }}
                        />
                    </WorkforceDetailsFieldComponent>
                )}
            />

            <Controller
                name="technicianGroupId"
                control={control}
                defaultValue={workforceCaseDetails?.technicianGroup?.id}
                render={({field}) => (
                    <WorkforceDetailsFieldComponent
                        fieldName={"Assign To"}
                        fieldId={"assignTo"}
                    >
                        <Select
                            placeholder={"Select a value"}
                            value={field.value}
                            id={"technicianGroupId"}
                            onChange={field.onChange}
                            options={state?.technicianGroupsDropdown?.map((statusTypes) => {
                                return {
                                    label: statusTypes?.name,
                                    value: statusTypes?.id,
                                };
                            }) ?? []}
                            className={
                                "w-full font-light placeholder:text-light-grey-500"
                            }
                        />
                    </WorkforceDetailsFieldComponent>
                )}
            />
            <WorkforceDetailsFieldComponent
                fieldName={"Consumer Name"}
                fieldId={"consumerName"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"consumerName"}
                    value={workforceCaseDetails?.device?.consumerName}
                />
            </WorkforceDetailsFieldComponent>
            <WorkforceDetailsFieldComponent fieldName={"Address"} fieldId={"address"} className={"col-start-2"}>
                <TextArea
                    disabled={true}
                    placeholder=""
                    id={"address"}
                    value={workforceCaseDetails?.fullAddress}
                />
            </WorkforceDetailsFieldComponent>


        </div>
    );
}

export default EditableAlarmCaseDetails;